var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"arrow_Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"arrow_Atom/Button/Ghost/Small","transform":"translate(-9.000000, -10.000000)"},React.createElement("g",{"id":"arrow_SmallArrow/white","transform":"translate(9.000000, 10.000000)"},[React.createElement("path",{"d":"M15.6923676,4.02832031 L4.00486755,4.02832031","id":"arrow_Line-5","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square","key":0}),React.createElement("polygon",{"id":"arrow_Triangle","fill":"currentColor","fillRule":"evenodd","transform":"translate(4.250000, 4.000000) rotate(-90.000000) translate(-4.250000, -4.000000) ","points":"4.25 -0.25 8.25 8.25 0.25 8.25","key":1})]))));
}

Arrow.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 17 8","version":"1.1"};

module.exports = Arrow;

Arrow.default = Arrow;
